// @flow
import { createAction } from 'redux-actions';

export const NONE = 'NONE';
export const PRIMARY = 'PRIMARY';
export const SECONDARY = 'SECONDARY';

export const openSettingsModal = createAction('OPEN_SETTINGS_MODAL');
export const closeSettingsModal = createAction('CLOSE_SETTINGS_MODAL');



// WEBPACK FOOTER //
// ./src/core/state/settings-modal/actions.js